import React from 'react';
import { Layout } from '@99designs/apps/spa/pages/auth/SSO/Layout';
import { Button } from '@99designs/emu';
import { linkTo } from '@99designs/routing';

export function CookieError() {
    return (
        <Layout heading={__placeholder('Error')}>
            <div>{__placeholder('There was an error with your cookies')}</div>

            <Button data-testid="ok-button" appearance="secondary" href={linkTo.home()}>
                {__placeholder('OK')}
            </Button>
        </Layout>
    );
}
